import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <div className="divide-y divide-edge border-y border-edge" data-id="element-544" data-mp="1l9o6f7npxxl7">
      {faqs.map((item, i) => {
      const isOpen = open === i;
      return <div key={item.q} data-id="element-545" data-mp="2e0pphjuj8da0" data-mpi={i}>
            <h3 data-id="element-546" data-mp="2dzxtw90xqfjq">
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="group flex w-full items-center justify-between gap-6 py-5 text-left" data-id="element-547" data-mp="2dyda9eg5sh0n">
                <span className={`font-display text-lg font-bold tracking-tight transition-colors duration-200 ease-smooth sm:text-xl ${isOpen ? 'text-ember' : 'text-chalk group-hover:text-ember'}`} data-id="element-548" data-mp="1z25hvqulk9aa">
                  {item.q}
                </span>
                {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-ember" aria-hidden="true" data-id="element-549" data-mp="uh0vg9f46nn3" /> : <PlusIcon className="h-5 w-5 shrink-0 text-dim" aria-hidden="true" data-id="element-550" data-mp="fk0d2witc51a" />}
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-551" data-mp="khjv87imt1yi">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-552" data-mp="6r6ilrusoz2u">
                  <p className="max-w-2xl pb-6 text-sm leading-relaxed text-dim" data-id="element-553" data-mp="1svdfufg3cqy">{item.a}</p>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}